"use client";

import Image from "next/image";
import Link from "next/link";
import { Col, Container, Row } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";

import "./BlogDetails.scss";

import BlocksRenderer from "@/components/BlocksRenderer/BlocksRenderer";

const BlogDetails = ({ blog, blogs = [] }) => {
  if (!blog) return null;

  const { title, content, slug, image, date, author, category } = blog;

  const latestPosts = blogs.filter((post) => post.slug !== slug).slice(0, 3);

  return (
    <section className="blog-details">
      <Container>
        <Row>
          <Col xl={8} xxl={8} lg={8}>
            <div className="blog-details-main">
              <h1 className="blog-title">{title}</h1>

              {image && (
                <div className="blog-featured-image">
                  <Image
                    src={image}
                    alt={title}
                    width={770}
                    height={350}
                    priority
                    className="featured-image"
                  />
                </div>
              )}

              <div className="blog-content">
                <BlocksRenderer
                  content={content}
                  comparisonTable={blog.comparisonTable}
                  comparisonTable1={blog.comparisonTable1}
                  comparisonTable2={blog.comparisonTable2}
                  comparisonTable3={blog.comparisonTable3}
                  comparisonTable4={blog.comparisonTable4}
                  comparisonTable5={blog.comparisonTable5}
                  // comparisonTable={blog.comparisonTable}
                  // comparisonTables={blog.comparisonTables}
                />
              </div>
            </div>
          </Col>

          <Col xl={4} xxl={4}>
            <div className="latest-posts">
              <h2>Latest posts</h2>

              {latestPosts.length ? (
                latestPosts.map((post) => (
                  <div className="post-image" key={post.slug}>
                    <Link href={`/blog/${post.slug}`}>
                      <div className="image-wrapper">
                        {post.image ? (
                          <Image
                            src={post.image}
                            alt={post.title}
                            fill
                            sizes="(max-width: 992px) 100vw, 360px"
                            className="post-card-image"
                          />
                        ) : (
                          <div className="blog-image-placeholder">Blog</div>
                        )}
                      </div>

                      <div className="latest-blogs">
                        <span className="blog-people">
                          <FaUserCircle />
                          <p>{post.author || "Admin"}</p>
                        </span>

                        <p className="text">{post.title}</p>
                      </div>
                    </Link>
                  </div>
                ))
              ) : (
                <p className="no-posts">No latest posts available.</p>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BlogDetails;
